module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/april-7c4fed43cc40208988018c58748fb033.png";